import { z } from 'zod';

const donorEmailSchema = z.string().email();

export function normalizeDonorEmail(email: string): string {
  return email.trim();
}

export function isDonorEmailValid(email: string): boolean {
  return donorEmailSchema.safeParse(normalizeDonorEmail(email)).success;
}
